var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    fill: "currentColor",
    viewBox: "0 0 24 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.317 1h1.552v21.04l4.143-4.12 1.094 1.1L12.093 25 6 19.007l1.094-1.108 4.223 4.162V1Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDownFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ArrowDownFilled.6359f9aab7ea27a29efee70f0ff0ca5d.svg";